import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../login/AuthContext";
import { useNavigate } from "react-router-dom";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const ShippingPreference = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.ShippingPreference[key][currentLang];

  const { userId, liveCsrfToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isInitialized, setIsInitialized] = useState(false);
  const [MinorCardShipping, setMinorCardShipping] = useState(0);
  const [MediumCardShipping, setMediumCardShipping] = useState(0);
  const [BigCardShipping, setBigCardShipping] = useState(0);
  const [AdditionalCard, setAdditionalCard] = useState(0);
  const [ShippingToCanada, setShippingToCanada] = useState(true);
  const [ShippingToUs, setShippingToUs] = useState(false);
  const [ShippingCostToUs, setShippingCostToUs] = useState(0);
  const [otherDetails, setOtherDetails] = useState("");
  const [isNewShippingPreference, setIsNewShippingPreference] = useState(false);
  const [selectedShippingPreferenceId, setSelectedShippingPreferenceId] =
    useState(null);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_BASE}/api/get/shipping-preferences/${userId}`
    , {
  method: 'GET',
  credentials: 'include', // Ensures cookies (like session) are sent
})
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setSelectedShippingPreferenceId(data.ShippingPreferenceId);
          setMinorCardShipping(data.MinorCardShipping);
          setMediumCardShipping(data.MediumCardShipping);
          setBigCardShipping(data.BigCardShipping);
          setAdditionalCard(data.AdditionalCard);
          setShippingToCanada(data.ShippingToCanada);
          setShippingToUs(data.ShippingToUs);
          setShippingCostToUs(data.ShippingCostToUs);
          setOtherDetails(data.OtherDetails);
          setIsNewShippingPreference(false);
        }
        setIsInitialized(true);
      })
      .catch((error) => {
        console.error("Error fetching shipping preferences:", error);
        setIsInitialized(true);
      });
  }, [userId]);

  const handleInputChange = (field, value) => {
    switch (field) {
      case "MinorCardShipping":
        setMinorCardShipping(value);
        break;
      case "MediumCardShipping":
        setMediumCardShipping(value);
        break;
      case "BigCardShipping":
        setBigCardShipping(value);
        break;
      case "AdditionalCard":
        setAdditionalCard(value);
        break;
      case "ShippingToCanada": // ✅ Missing case
        setShippingToCanada(value);
        break;
      case "ShippingToUs":
        setShippingToUs(value);
        break;
      case "ShippingCostToUs":
        setShippingCostToUs(value);
        break;
      case "otherDetails":
        setOtherDetails(value);
        break;
      default:
        break;
    }
  };

  const handleSave = () => {
    const updatedData = {
      ShippingPreferenceId: selectedShippingPreferenceId,
      MinorCardShipping,
      MediumCardShipping,
      BigCardShipping,
      AdditionalCard,
      ShippingToCanada,
      ShippingToUs,
      ShippingCostToUs,
      otherDetails,
    };

    const requestUrl = isNewShippingPreference
      ? `${process.env.REACT_APP_API_BASE}/api/add/shipping-preferences`
      : `${process.env.REACT_APP_API_BASE}/api/update/shipping-preferences/${selectedShippingPreferenceId}`;

    const method = isNewShippingPreference ? "POST" : "PUT";

    fetch(requestUrl, {
      method,
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": liveCsrfToken,
      },
      credentials: "include",
      body: JSON.stringify({ userId, updatedData }),
    })
      .then((response) => {
        if (response.ok) {
          toast.success(
            isNewShippingPreference
              ? "Shipping preference created successfully"
              : "Shipping preference updated successfully"
          );
        } else {
          toast.error("Failed to save shipping preference");
        }
      })
      .catch((error) => {
        console.error("Error saving shipping preference:", error);
        toast.error("An error occurred while saving the shipping preference");
      });
  };

  // Toggle the shipping to Canada button
  const handleToggleCanada = () => {
    setShippingToCanada((prev) => !prev);
  };

  // Toggle the shipping to USA button
  const handleToggleUs = (next) => {
    setShippingToUs(next);
    if (next) setTimeout(() => document.getElementById('ShippingToUs')?.focus(), 0);
  };

  const resetAll = () => {
    setAdditionalCard(0.5);
    setBigCardShipping(20);
    setMediumCardShipping(15);
    setMinorCardShipping(3);
    setShippingToCanada(true);
    setShippingToUs(false);
    setShippingCostToUs(0);
    setOtherDetails("");
  };

  const createShippingInput = (fieldName, label) => {
    // Map field names to state values
    const fieldValue = {
      MinorCardShipping,
      MediumCardShipping,
      BigCardShipping,
      AdditionalCard,
      ShippingCostToUs,
      otherDetails,
    }[fieldName]; // ✅ Get value dynamically

    return (
      <div className="shipping-input-group">
        <label htmlFor={fieldName}>{label}</label>
        <input
          type="text"
          id={fieldName}
          className="shipping-input"
          value={fieldValue} // ✅ Now using correct state value
          onChange={(e) => handleInputChange(fieldName, e.target.value)}
          maxLength={6}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^0-9.]/g, "");
          }}
        />
      </div>
    );
  };

return (
  <div className="shipPref">
    <div className="shipPref__card">
      <div className="shipPref__header">
        <h2>{t('Shipping Cost')} ($)</h2>

       
      </div>

      {/* price tiers */}
      <div className="shipPref__gridPrices">
        {createShippingInput('MinorCardShipping', t('Under 25$'))}
        {createShippingInput('MediumCardShipping', t('Under 75$'))}
        {createShippingInput('BigCardShipping', t('Over 75$'))}
        {createShippingInput('AdditionalCard', t('Per Additional Card($)'))}
      </div>

      <hr className="shipPref__divider" />

      {/* destination + details */}
      <div className="shipPref__layout">
        <div className="shipPref__dest">
          {/* Canada */}
          <div className="shipPref__destItem">
            <label className="shipPref__label">{t('Ship (in/to) Canada')}</label>
            <button
              type="button"
              className={`toggle ${ShippingToCanada ? 'is-on' : 'is-off'}`}
              aria-pressed={ShippingToCanada}
              onClick={handleToggleCanada}
            >
              {ShippingToCanada ? t('Active') : t('Inactive')}
            </button>
          </div> 

          {/* USA */}
      <div className="shipPref__destItem">
  <div className="shipPref__destHeader">
    <span className="shipPref__destTitle">{t('Ship (in/to) USA')}</span>

    <div className="toggle-group">
      <button
        type="button"
        className={`toggle ${ShippingToUs ? 'is-on' : ''}`}
        aria-pressed={ShippingToUs}
        onClick={()=>handleToggleUs(!ShippingToUs)}
      >
        {ShippingToUs ? t('Active') : t('Inactive')}
      </button>
    </div>
  </div>

  <div
    className={`shipPref__usCost ${ShippingToUs ? '' : 'is-disabled'}`}
    aria-disabled={!ShippingToUs}
  >
    <label htmlFor="usCost" className="shipPref__smallLabel">
      {t("Shipping Cost to USA")}
    </label>

    <input
      id="ShippingCostToUs"
      type="number"
      min={0}
      step={1}
      className="shipping-input"
      value={ShippingCostToUs}
      onChange={(e) => setShippingCostToUs(e.target.value)}
      disabled={!ShippingToUs}         // <-- stays visible, just disabled
      aria-describedby={!ShippingToUs ? 'usHelp' : undefined}
    />
    {!ShippingToUs && (
      <small id="usHelp" className="hint">
        {t('Enable to set shipping cost to USA')}
      </small>
    )}
  </div>
</div>
        </div>

        {/* other details */}
        <div className="shipPref__notes">
          <label htmlFor="otherDetails" className="shipPref__label">
            {t('Other Details')}
     
          <textarea
            id="otherDetails"
            className="shipPref__textarea"
            value={otherDetails}
            onChange={(e) => setOtherDetails(e.target.value)}
            maxLength={398}
          />     </label>
        </div>

         
      </div>
    </div>
    <div className="fullDiv">
    <div className="shipPref__actions">
          <button className="btn-ghost" style={{marginBottom:'0'}} onClick={resetAll}>
            {t('Clear the form')}
          </button>
          <button className="btn-baseBlue" onClick={handleSave}>
            {isNewShippingPreference ? t('Create') : t('Update')}
          </button>
        </div></div>
  </div>
);

};

export default ShippingPreference;
